// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoDataSection-noDataSectionWrapper-ENhIw {
    text-align: center;
}

.NoDataSection-noDataImage-Bg53H {
    max-width: 300px;
    max-height: 180px;
    margin: 0 auto 30px;
}

.NoDataSection-noDataImage-Bg53H>img {
    -o-object-fit: contain;
       object-fit: contain;
}

.NoDataSection-noDataTitleText-UkpHv {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    margin-bottom: 12px;
}

.NoDataSection-noDataDescText-TBRhz {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: var(--secondary-foreground);
    margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/ServicePlanContainer/NoDataSection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;AACvB","sourcesContent":[".noDataSectionWrapper {\n    text-align: center;\n}\n\n.noDataImage {\n    max-width: 300px;\n    max-height: 180px;\n    margin: 0 auto 30px;\n}\n\n.noDataImage>img {\n    object-fit: contain;\n}\n\n.noDataTitleText {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 30px;\n    text-align: center;\n    margin-bottom: 12px;\n}\n\n.noDataDescText {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--secondary-foreground);\n    margin-bottom: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noDataSectionWrapper": `NoDataSection-noDataSectionWrapper-ENhIw`,
	"noDataImage": `NoDataSection-noDataImage-Bg53H`,
	"noDataTitleText": `NoDataSection-noDataTitleText-UkpHv`,
	"noDataDescText": `NoDataSection-noDataDescText-TBRhz`
};
module.exports = ___CSS_LOADER_EXPORT___;
